import { forwardRef, memo, type Ref } from 'react';
import { FormDropdown } from '~/commonComponents/FormDropdown';
import { DropdownOption } from '~/commonComponents/FormDropdown/DropdownOption';

interface IProfessionalTypeFieldProps {
  value?: string;
  onChange?: (value: string) => void;
  isOpen: boolean;
  onToggle: () => void;
  professionOptions: { code: string; name: string }[];
}

const Component = (
  { value, onChange, isOpen, onToggle, professionOptions }: IProfessionalTypeFieldProps,
  ref: Ref<HTMLDivElement>,
) => {
  return (
    <div ref={ref}>
      <FormDropdown
        label="Professional Type"
        value={value || undefined}
        isOpen={isOpen}
        onToggle={onToggle}
        testId="professional-type-field"
      >
        {professionOptions.map((option) => (
          <DropdownOption
            key={option.code}
            isSelected={value === option.name}
            onSelect={() => {
              onChange?.(option.name);
              onToggle();
            }}
            testId={`profession-option-${option.code}`}
          >
            {option.name}
          </DropdownOption>
        ))}
      </FormDropdown>
    </div>
  );
};

export const ProfessionalTypeField = memo(forwardRef(Component));
